import React, { useState } from 'react';
import { useChatTheme, useThemeStyles } from '../../contexts/ChatThemeContext';

interface ChatContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({ children, className = '' }) => {
  const { theme } = useChatTheme();
  const styles = useThemeStyles();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`chat-interface ${className}`}
      style={{
        ...styles.container,
        ...(isHovered ? styles.containerHover : {}),
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  );
};